import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type MenusState, moduleName } from "./menus.types";

const initialState: MenusState = {
	openMenuId: null,
};

const menusSlice = createSlice({
	name: moduleName,
	initialState,
	reducers: {
		setOpenMenu: (state, action: PayloadAction<string | null>) => {
			state.openMenuId = action.payload;
		},
	},
});

export default menusSlice;
